// @flow

import { LkTypeDialogController } from "./modal/lkType-controller";

const { document } = require("window");
import _ from "lodash";
import ko from "rgs-knockout";
import moment from 'moment';
import $ from 'rgs-jquery';

import { initNamespaceStorage } from "js-storage";
import vb from 'validation-builder';
import { sessionId } from 'session-id';

import server from "server";
import { default as server2, lkRoute } from "server2";
import TraceKit from "rgs-tracekit";
import page from "page-common";

import { profile } from "myrgs-auth-helpers-user";
import {
	YandexSmartCaptcha,
	YandexSmartCaptchaInvisible,
	fetchYandexSmartCaptchaJsOnce,
} from "yandex-smart-captcha";
import { default as browserDetector } from 'browser-type-detector';

import { Error, ignoreHandledErrors } from "error";

import type { Observable, PureComputed } from "rgs-knockout";

import MyrgsLoginOrRegisterOrLoginThrougEsiaFormModel from "ko-component-myrgs-auth-form";
import 'ko-component-yandex-smart-captcha';
import 'ko-component-yandex-smart-captcha-invisible';
import type {
	MyrgsFormModelParams,
	ValidationMode,
} from "ko-component-myrgs-auth-form";
import { Modal } from "modals/js/modals";
import FaceTemplate from "../templates/faceId-template.html";
import PhoneAuthModalTemplate from '../templates/phone-auth-modal-template.html';
import BankAuthErrorModalTemplate from '../templates/bank-auth-error-modal.html';
import BankAuthTimerErrorModalTemplate from '../templates/bank-auth-timer-error-modal.html';
import NewLkHrDmsNotificationTemplate from '../templates/notifications/new-lk-hr-dms.html';
import { createReactComponentModel } from "./components";
import type { CreateComponentProps } from "./components";

import LkTypeStorageExecutor from "./utils/lk-type-storage-executor";
import window from "window";
import EventEmitter from "events";

import {
	faceIdNames,
	faceIdStatus,
	faceIdError,
	phoneLoginErrorMessage,
	VTB_AUTH_URL_STATUS,
	TIMER_URL_PARAM,
	bankAuthErrorMessage,
} from "../constants";
import type { PhoneLoginStatus, BankAuthStatus } from "../constants";
import {
	asyncCheckIfPlatformVerificationAvailable,
	checkIfMobile,
} from "./utils/user-platform-checker";
import {
	bufferToBase64,
	base64ToBuffer,
	encodeToBase64,
} from "./utils/decoder-encoder";
import {
	getAssertionOptions,
	getCredentialOptions,
	registerWebAuthFetch,
	loginWebAuthFetch,
} from "../web-auth-api";
import { webauthnAbortService } from "./utils/webauthn-abort-service";
import { ObservableDisableTimer } from 'observable-disable-timer';
import type {
	ObservableDisableTimer as IObservableDisableTimer,
} from 'observable-disable-timer';

import { getStatisticsQueries } from 'app-my-dms-insurance/app/utils/get-statistics-req-query';

import {
	isDmsAuthenticationShouldBeBlocked,
	showDmsAuthenticationBlockedStub
} from './utils/dms-authentication-blocker-stub';

export type ExtendedValidationOptions = { mode: ValidationMode };

type MyrgsAuthFormModelParams = {
	...MyrgsFormModelParams,
	withRegistration: boolean,
	justHideAuthModalOnCancel?: boolean,
};

const CAPTCHA_IGNORED_ERROR = "Пройдите проверку";

class AuthModel extends MyrgsLoginOrRegisterOrLoginThrougEsiaFormModel {
	_params: MyrgsAuthFormModelParams;
	_lkTypeStorage: LkTypeStorageExecutor;
	isPersonTypeJuridical: Observable<null | boolean>;
	isTypeChecked: Observable<"Physical" | "Juridical" | "Ip" | null>;
	PersonType: Observable<"Physical" | "Juridical" | undefined>;
	IpType: Observable<"Juridical" | "Ip" | undefined>;
	ProductType: Observable<null | string>;
	loginMode: Observable<boolean>;
	registrationMode: Observable<boolean>;
	loginByPhoneIsActive: Observable<boolean>;
	isPwaMode: PureComputed<boolean>;
	Code: Observable<string>;
	viewCanBeBlocked: Observable<boolean>;
	isViewBlocked: PureComputed<boolean>;
	juridicalPersonPasswordVisible: Observable<boolean>;
	passwordVisibility: Observable<boolean>;
	passwordInvisibility: Observable<boolean>;
	notificationPlate: Observable<boolean>;
	notificationPlateText: Observable<string>;
	notificationLine: Observable<boolean>;
	notificationLineText: Observable<string>;
	notificationWithTimer: Observable<boolean>;
	notificationWithTimerText: Observable<string>;
	notificationWithTimerAndBlocker: Observable<boolean>;
	smsIsSent: Observable<boolean>;
	anotherCodeReqIsAllowed: Observable<boolean>;
	anotherCodeBtnIsVisible: PureComputed<boolean>;
	notificationEmail: Observable<boolean>;
	notificationEmailText: Observable<string>;
	notificationPassword: Observable<boolean>;
	notificationPasswordText: Observable<string>;
	yaCaptchaPhysicalRegisterValidationSource: Observable<any>;
	eyeBtnVisibility: Observable<boolean>;
	isMobile: Observable<boolean>;
	withFaceID: Observable<boolean>;
	platformIsSuitable: Observable<boolean>;
	faceIdAuthIsFetching: Observable<boolean>;
	currentUserEmail: Observable<string>;
	currentUserProfileId: Observable<number | null>;
	webAuthnAssertionOptions: Observable<any>;
	webAuthnRegOptions: Observable<any>;
	timer: IObservableDisableTimer;
	timerString: PureComputed<string>;
	phoneFormMobileRequired: Observable<boolean>;
	phoneFormCanBeRendered: Observable<boolean>;
	phoneFormMobileVisible: PureComputed<boolean>;

	constructor (...args) {
		super(...args);
		const [params] = args;

		const yaCaptchaReady = fetchYandexSmartCaptchaJsOnce();
		const eventEmitter = new EventEmitter();
		window["jurdicalRegEventEmitter"] = eventEmitter;
		window["ipRegEventEmitter"] = eventEmitter;
		window["actionEventEmitter"] = eventEmitter;


		this._params = _.defaultsDeep({}, params, {
			disablePersonType: false,
			withRegistration: false,
			justHideAuthModalOnCancel: false,
			prefilling: {
				PersonType: undefined,
				Email: undefined,
			},
			event: {
				authSuccess: undefined,
				registrationMode: undefined,
			},
			components: {
				jurdicalReg: {
					entrypoints: "/media/sys-ng2/dist/entrypoints.json",
					name: "jurdical-registration-react-component",
					eventEmitterName: "jurdicalRegEventEmitter",
				},
				// TODO if it works find a better way
				lpReg: {
					entrypoints: "/media/sys-ng2/dist/entrypoints.json",
					name: "jurdical-registration-react-component",
					eventEmitterName: "ipRegEventEmitter",
				},
			},
		});


		this.isYaCaptchaJsFetched = ko.observable();

		const isPwa = browserDetector.isStandalonePwa();
		this.isPwaMode = ko.pureComputed(() => isPwa);
		this.Code = ko.observable('')
			.extend({
				validation: vb.all([
					vb.required(),
					vb.lengthMin(4),
					vb.lengthMax(4),
				]),
			})
			.extend({
				validationLoggingName: 'Код',
			})
			.extend({ toFromJS: true });

		this.on("registrationClick", this._registrationClick.bind(this));
		this.on("isVisibleClick", this._isVisibleClick.bind(this));
		this.on(
			"closeNotificationClick",
			this._closeNotificationClick.bind(this)
		);
		this.on(
			"checkEyeBtnVisibility",
			this._checkEyeBtnVisibility.bind(this)
		);
		this.on("authWithFaceIdClick", this._authWithFaceIdClick.bind(this));
		this.on("phoneTabClick", this._switchToPhoneForm.bind(this));
		this.on("emailTabClick", this._switchToEmailForm.bind(this));
		this.on("getAnotherCode", this._getAnotherCodeClick.bind(this));
		this.on("showPhoneFormPwa", this._showPhoneFormPwa.bind(this));
		
		this.on("onBankAuthClick", this._onBankAuthClick.bind(this));

		this.on("onOsopoOsgop", this._onOsopoOsgop.bind(this));
		this.on("onGoToLoginModeClick", this._onGoToLoginModeClick.bind(this));
		this.on("onIpClick", this._onIpClick.bind(this));
		this.on("onJurdicalClick", this._onJurdicalClick.bind(this));
		this.on("onPhisicalClick", this._onPhisicalClick.bind(this));

		if (this._params.event.registrationMode) {
			this.on("registrationMode", this._params.event.registrationMode);
		}

		this.on('authSuccess', () => {
			/* В случае успешного логина разрушаем невидимую капчу, иначе на странице
			   останется висеть shield яндекса о политике использования. Это актуально для
			   модалки повторного логина, когда после логина страница не изменяется.
			 */
			if (this.isInvisibleCaptchaUsageZone()) {
				this.yaCaptchaLogin.destroy();
			}
		});

		this.justHideAuthModalOnCancel = ko.constant(params.justHideAuthModalOnCancel);

		this.yaCaptchaLogin = new YandexSmartCaptchaInvisible("captcha-container-on-login", {
			onSuccess: () => {
				this._busy
					.add(this._login())
					.catch(ignoreHandledErrors)
					.done();
			},
			onJsCriticalError: () => {
				// eslint-disable-next-line max-len
				TraceKit.tryReport(`YaCaptcha: произошло событие 'javascript-error' для email=${this.Email()}`);
			},
			onNetworkError: () => {
				// eslint-disable-next-line max-len
				TraceKit.tryReport(`YaCaptcha: произошло событие 'network-error' для email=${this.Email()}`);
			},
		});
		// eslint-disable-next-line max-len
		this.yaCaptchaPhysicalRegisterValidationSource = ko.observable().extend({validation: vb.all([])});
		// eslint-disable-next-line max-len
		this.yaCaptchaPhysicalRegister = new YandexSmartCaptcha("captcha-container-on-physical-register", {
			onBeforeRender: () => {
				this.yaCaptchaPhysicalRegisterValidationSource.clearError();
			},
			onSuccess: () => {
				this.yaCaptchaPhysicalRegisterValidationSource.clearError();
			},
		});

		this.Email.subscribe(v => {
			if ((v && v.toUpperCase()) === '@@ CAPTCHA CHALLENGE') {
				this.yaCaptchaLogin.render({ withChallenge: true });
				setTimeout(() => {
					this.Email('');
				}, 0);
			} else if ((v && v.toUpperCase()) === '@@ SHOW SESSION') {
				setTimeout(() => {
					this.Email(sessionId());
				}, 0);
			}
		});

		this.withRegistration = this._params.withRegistration;

		const isLoginMode = true;
		this.loginMode = ko.observable(isLoginMode);
		this.registrationMode = ko.observable(!isLoginMode);
		const emailTabVisible = true;
		this.loginByPhoneIsActive = ko.observable(!emailTabVisible);

		this.isInvisibleCaptchaUsageZone = ko.pureComputed(() => {
			// Не ЕСИА (Mode=Rgs) + логин (не из регистрации) + не по телефону
			return this.Mode() === 'Rgs'
				&& this.loginMode()
				&& !this.loginByPhoneIsActive();
		});

		const handleInvisibleCaptchaUsageZoneChange = (isInvisibleCaptchaUsageZone) => {
			if (!this.isYaCaptchaJsFetched()) {
				return;
			}

			if (isInvisibleCaptchaUsageZone === true) {
				this.yaCaptchaLogin.render();
			} else {
				/*
				 Уничтожаем капчу, чтоб пропал shield яндекса о политике использования.
				 Мы не хотим видеть shield на регистрации, email-логине и т.д. (там где невидимая капча не нужна)
				*/
				this.yaCaptchaLogin.destroy();
			}
		};

		this.isInvisibleCaptchaUsageZone.subscribe(handleInvisibleCaptchaUsageZoneChange);
		yaCaptchaReady
			.then(() => {
				this.isYaCaptchaJsFetched(true);
				setTimeout(() => {
					handleInvisibleCaptchaUsageZoneChange(this.isInvisibleCaptchaUsageZone());
				}, 0);
			})
			.catch(() => {
				this.isYaCaptchaJsFetched(false);
			});

		this.juridicalPersonPasswordVisible = ko.observable(false);
		this.isPersonTypeIp = ko.observable(false);
		this.isTypeChecked = ko.observable(null);
		this.PersonType = ko
			.pureComputed({
				read: () => {
					this.ProductType(null);
					if (
						!this.isPersonTypeJuridical()
						&& this.isPersonTypeIp()
					) {
						setTimeout(() => {
							const eventEmitter = _.get(
								window,
								"jurdicalRegEventEmitter"
							);
							if (eventEmitter) {
								eventEmitter.emit(
									"render-jurdical-registration-react-component"
								);
							}
						}, 0);
						return "Juridical";
					}

					if (
						this.isPersonTypeJuridical()
						&& this.isPersonTypeIp() === false
					) {
						setTimeout(() => {
							const eventEmitter = _.get(
								window,
								"jurdicalRegEventEmitter"
							);
							if (eventEmitter) {
								eventEmitter.emit(
									"render-jurdical-registration-react-component"
								);
							}
						}, 0);
						return "Juridical";
					}
					if (
						this.isPersonTypeJuridical() === false
						&& !this.isPersonTypeIp()
					) {
						return "Physical";
					}
					return null;
				},
				write: v => this.isPersonTypeJuridical("Juridical" === v),
			})
			.extend({ toFromJS: true, deferred: true });
		this.UserHasPassword = ko
			.pureComputed(
				() => this.loginMode() || this.isPersonTypeJuridical()
			)
			.extend({ toFromJS: true })
			.extend({ notEqual: null });

		this.ProductType = ko.observable(null).extend({ notEqual: null });

		this.isPersonTypeJuridical = ko.observable(
			this._params.prefilling.PersonType
				&& this._params.prefilling.PersonType === "Juridical"
		);

		this._setCaptcha();
		this.passwordVisibility = ko.observable(false);
		this.passwordInvisibility = ko.observable(true);
		this.notificationPlate = ko.observable(false);
		this.notificationPlateText = ko.observable(
			"Превышено количество неудачных попыток ввода пароля. Повторите вход позднее."
		);
		this.notificationLine = ko.observable(false);
		this.notificationLineText = ko.observable(
			"Превышено количество неудачных попыток ввода пароля. Повторите вход позднее."
		);
		this.notificationWithTimer = ko.observable(false);
		this.notificationWithTimerText = ko.observable(
			// eslint-disable-next-line max-len
			"Превышено количество попыток получения проверочного кода. Вы сможете получить новый код через"
		);
		this.notificationWithTimerAndBlocker = ko.observable(false);
		this.smsIsSent = ko.observable(false);
		this.timer = new ObservableDisableTimer({
			timeout: [0, 'second'],
		});
		this.timerString = ko.pureComputed(() => {
			const time = this.timer.timeoutRemaining();
			const secs = moment.duration(time).seconds();
			const mins = moment.duration(time).minutes();
			return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
		});
		this.anotherCodeReqIsAllowed = ko.observable(false);
		this.anotherCodeBtnIsVisible = ko.pureComputed(() => {
			const isVisible = this.loginByPhoneIsActive()
				&& this.smsIsSent()
				&& (this.timer.timeoutRemaining() < 1000)
				&& this.anotherCodeReqIsAllowed();
			return isVisible;
		});
		this.viewCanBeBlocked = ko.observable(false);
		this.isViewBlocked = ko.pureComputed(() => {
			const isBlocked = this.viewCanBeBlocked() && (this.timer.timeoutRemaining() > 0);
			return isBlocked;
		});
		this.notificationEmail = ko.observable(false);
		this.notificationEmailText = ko.observable(
			"Пользователя с таким E-mail не существует"
		);
		this.notificationPassword = ko.observable(false);
		this.notificationPasswordText = ko.observable(
			"Проверьте, правильно ли введен пароль"
		);
		this.eyeBtnVisibility = ko.observable(false);
		this.isMobile = ko.pureComputed(() => checkIfMobile());
		this.withFaceID = ko.observable(false);
		this.platformIsSuitable = ko.observable(false);
		this.faceIdAuthIsFetching = ko.observable(false);
		this.currentUserEmail = ko.observable("");
		this.currentUserProfileId = ko.observable(null);
		this.webAuthnAssertionOptions = ko.observable(null);
		this.webAuthnRegOptions = ko.observable(null);

		this.phoneFormMobileRequired = ko.observable(false);
		this.phoneFormCanBeRendered = ko.observable(false);
		this.phoneFormMobileVisible = ko.pureComputed(() => {
			if (!this.isMobile()) {
				return true;
			}
			return this.phoneFormMobileRequired() && this.phoneFormCanBeRendered();
		});

		this.faceModal = new Modal({
			templateMode: "body",
			title: "New title",
			template: {
				html: FaceTemplate(),
				data: {
					agreeHandler: this._handleAgreeToFaceId,
					remindHandler: this._handleRemindLaterFaceId,
					refuseHandler: this._handleRefuseFaceId,
					isLoading: this.faceIdAuthIsFetching,
				},
			},
			userCanClose: true,
			css: { "modal-face-auth": true },
		});
		this.faceModal._createModal();
		this.faceModal._applyBindings();

		this.phoneAuthRedirectModal = new Modal({
			templateMode: "body",
			title: "New title",
			template: {
				html: PhoneAuthModalTemplate(),
				data: {
					isPwaMode: this.isPwaMode,
					goToEmailHandler: this._goToEmailHandler,
					goToRegistrationHandler: this._registrationClick,
				},
			},
			userCanClose: true,
			css: { "modal-no-phone": true },
		});
		this.phoneAuthRedirectModal._createModal();
		this.phoneAuthRedirectModal._applyBindings();

		// this.toAuthJS(), а точнее this.toJS() ломает валидацию серии и номера паспорта на странице регистрации.
		// решил обойти это таким вот образом
		this.lkTypeControllerInstance = new LkTypeDialogController({
			Email: this.Email.toJS(),
			Password: this.Password.toJS(),
		});

		this._lkTypeStorage = new LkTypeStorageExecutor();

		this._lkTypeStorage = new LkTypeStorageExecutor();

		this._faceIdStorage = initNamespaceStorage(
			faceIdNames.storageSpace
		).localStorage;
		this._prepareFaceID();
		this._initialize();
		this._handleBankAuthErrors();

		page.notifications.push({
			template: {
				html: NewLkHrDmsNotificationTemplate(),
			},
		});
	}

	_initialize = () => {
		const eventEmitter = _.get(
			window,
			"actionEventEmitter"
		);

		eventEmitter.on("back-action", () => {
			window.location.replace(window.location.origin);
		});
	}
	_prepareFaceID = async () => {
		const platformSuitable = await asyncCheckIfPlatformVerificationAvailable();
		this.platformIsSuitable(platformSuitable);
		const hasFaceIdCredentials = !this._faceIdStorage.isEmpty(
			faceIdNames.credentialId
		);
		const storageKeysArr = this._faceIdStorage.keys();

		let hasEnabledFaceId = false;
		if (storageKeysArr.length > 0) {
			const statusesKeys = storageKeysArr.filter(key =>
				key.includes(faceIdNames.storageParam)
			);
			if (statusesKeys.length > 0) {
				const isEnabled = statusesKeys.find(el => {
					return this._faceIdStorage.get(el) === faceIdStatus.on;
				});
				hasEnabledFaceId = Boolean(isEnabled);
			}
		}

		const credentialId = this._faceIdStorage.get(faceIdNames.credentialId);
		if (credentialId) {
			const optionsReqData = {
				credentialID: credentialId,
			};

			const assertionOptions = await getAssertionOptions(optionsReqData);

			assertionOptions.challenge = base64ToBuffer(
				assertionOptions.challenge
			);
			assertionOptions.allowCredentials = [
				{
					id: base64ToBuffer(credentialId),
					type: "public-key",
					transports: ["internal"],
				},
			];
			assertionOptions.userVerification = "preferred";
			delete assertionOptions.rpId;

			this.webAuthnAssertionOptions(assertionOptions);
		}

		const faceIdVisibility
			= this.isMobile()
			&& hasEnabledFaceId
			&& hasFaceIdCredentials
			&& platformSuitable;

		if (faceIdVisibility) {
			this.withFaceID(true);
		} else {
			this.phoneFormMobileRequired(true);
		}

		this.phoneFormCanBeRendered(true);
	};

	_authWithFaceIdClick = async () => {
		await this._askNotificationPermission();
		return this._busy
			.add(this._authenticateWithFaceId())
			.catch(ignoreHandledErrors)
			.done();
	};

	_authenticateWithFaceId = async () => {
		try {
			const credential = await window.navigator.credentials
				.get({
					publicKey: this.webAuthnAssertionOptions(),
					signal: webauthnAbortService.createNewAbortSignal(),
				})
				.catch(err => {
					page.notifications.push({
						css: { "notification-danger": true },
						message: faceIdError.extendedTryLater,
					});
					err.handled = true;
				});

			if (!credential) {
				return;
			}

			const assertionOptions = this.webAuthnAssertionOptions();
			const data = {
				rawId: bufferToBase64(credential.rawId),
				assertionOptionsID: assertionOptions.assertionOptionsID,
				id: assertionOptions.id,
				type: assertionOptions.type,
				response: {
					authenticatorData: bufferToBase64(
						credential.response.authenticatorData
					),
					clientDataJSON: bufferToBase64(
						credential.response.clientDataJSON
					),
					signature: bufferToBase64(credential.response.signature),
					userHandle: bufferToBase64(credential.response.userHandle),
					id: credential.id,
					type: credential.type,
				},
			};

			await this._loginWebAuth(data);
		} catch (error) {
			error.handled = true;
			throw error;
		}
	};

	_loginWebAuth (data) {
		return loginWebAuthFetch(data)
			.then(async (data) => {
				return this._handleWebPushSubscription(data);
			})
			.then(profile.update)
			.then(server.util.filter.authenticated)
			.then(() => this.emit("authSuccess"))
			.catch(error => {
				error.handled = true;
				throw error;
			});
	}

	_handleFaceIdInterception = async () => {
		const userProfileId = this.currentUserProfileId();
		const encodedId = encodeToBase64(userProfileId.toString());
		const faceIdSavedStatusById = this._faceIdStorage.get(
			`${faceIdNames.storageParam}_${encodedId}`
		);
		const email = this.currentUserEmail();
		let faceIdSavedStatusByEmail = false;
		if (email) {
			const encodedEmail = encodeToBase64(email);
			faceIdSavedStatusByEmail = this._faceIdStorage.get(
				`${faceIdNames.storageParam}_${encodedEmail}`
			);
		}
		const faceIdDecidedById
			= faceIdSavedStatusById === faceIdStatus.on
			|| faceIdSavedStatusById === faceIdStatus.off;
		const faceIdDecidedByEmail
			= faceIdSavedStatusByEmail === faceIdStatus.on
			|| faceIdSavedStatusByEmail === faceIdStatus.off;

		const needShowModel = !faceIdDecidedById && !faceIdDecidedByEmail;

		if (this.platformIsSuitable() && this.isMobile() && needShowModel) {
			try {
				const reqData = {
					// Username: email,
					// DisplayName: email,
					AttType: "none",
					AuthType: "platform",
					ResidentKey: "",
					UserVerification: "preferred",
				};

				const optionsRes = await getCredentialOptions(reqData);

				optionsRes.user.id = base64ToBuffer(optionsRes.user.id);
				optionsRes.challenge = base64ToBuffer(optionsRes.challenge);
				delete optionsRes.rp.id;

				this.webAuthnRegOptions(optionsRes);
			} catch (error) {
				this.emit("authSuccess");
				error.handled = true;
				throw error;
			}
			this.faceModal._show();
		} else {
			this.emit("authSuccess");
		}
	};

	_handleAgreeToFaceId = async () => {
		try {
			this.faceIdAuthIsFetching(true);
			const credential = await window.navigator.credentials
				.create({
					publicKey: this.webAuthnRegOptions(),
					signal: webauthnAbortService.createNewAbortSignal(),
				})
				.catch(err => {
					page.notifications.push({
						css: { "notification-danger": true },
						message: faceIdError.extendedTryLater,
					});
					err.handled = true;
				});

			if (!credential) {
				this.faceIdAuthIsFetching(false);
				this.emit("authSuccess");
				this.faceModal._hide();
				return;
			}

			const credentialId = bufferToBase64(credential.rawId);

			const clientData = bufferToBase64(
				credential.response.clientDataJSON
			);

			const data = {
				rawId: credentialId,
				id: credential.id,
				type: credential.type,
				response: {
					attestationObject: bufferToBase64(
						credential.response.attestationObject
					),
					clientDataJSON: clientData,
				},
			};

			const result = await registerWebAuthFetch(data);

			if (result) {
				const storageKeysArr = this._faceIdStorage.keys();

				if (storageKeysArr.length > 0) {
					const statusesKeys = storageKeysArr.filter(key =>
						key.includes(faceIdNames.storageParam)
					);
					if (statusesKeys.length > 0) {
						statusesKeys.forEach(el => {
							const isEnabled
								= this._faceIdStorage.get(el) === faceIdStatus.on;
							if (isEnabled) {
								this._faceIdStorage.set(el, "");
							}
						});
					}
				}

				this._faceIdStorage.set(faceIdNames.credentialId, credentialId);
				const userProfileId = this.currentUserProfileId();
				const encodedId = encodeToBase64(userProfileId.toString());
				this._faceIdStorage.set(
					`${faceIdNames.storageParam}_${encodedId}`,
					faceIdStatus.on
				);
				this._faceIdStorage.set(faceIdNames.currentUser, userProfileId.toString());
			}
		} catch (error) {
			error.handled = true;
			throw error;
		} finally {
			this.faceIdAuthIsFetching(false);
			this.emit("authSuccess");
			this.faceModal._hide();
		}
	};

	_handleRemindLaterFaceId = () => {
		this.emit("authSuccess");
	};

	_handleRefuseFaceId = () => {
		const userProfileId = this.currentUserProfileId();
		const encodedId = encodeToBase64(userProfileId.toString());
		this._faceIdStorage.set(
			`${faceIdNames.storageParam}_${encodedId}`,
			faceIdStatus.off
		);

		this.emit("authSuccess");
	};

	_jurdicalRegistrationComponent: CreateComponentProps<JurdicalRegComponentModel> = () => {
		// console.log('_jurdicalRegistrationComponent');
		return createReactComponentModel(
			"jurdical-registration-react-component",
			{}
		);
	};

	_isVisibleClick () {
		this.passwordVisibility(!this.passwordVisibility());
		this.passwordInvisibility(!this.passwordInvisibility());
		const el = document.querySelector("#my-login-form-password");
		if (el.getAttribute("type") === "password") {
			el.setAttribute("type", "text");
		} else {
			el.setAttribute("type", "password");
		}
	}

	_closeNotificationClick () {
		this.notificationPlate(false);
	}

	_checkEyeBtnVisibility () {
		this.eyeBtnVisibility(true);
	}

	_removeNotifications () {
		this.notificationPlate(false);
		this.notificationLine(false);
		this.notificationEmail(false);
		this.notificationPassword(false);
		this.yaCaptchaPhysicalRegisterValidationSource.clearError();
	}

	_scrollPlateToView () {
		const elem = document.querySelector("#notification-plate-to-scroll");
		elem.scrollIntoView({ behavior: "smooth", block: "end" });
	}

	_scrollErrorLineToView () {
		const elem = document.querySelector("#notification-error-line-to-scroll");
		elem.scrollIntoView({ behavior: "smooth", block: "end" });
	}

	_scrollInputWithErrorToView (elementId) {
		const elem = document.querySelector(elementId);
		elem.scrollIntoView({ behavior: "smooth", block: "start" });
	}

	_yaCaptchaReset () {
		const isCommonLogin = this.UserHasPassword();
		const isPhysicalRegistration = this.registrationMode() && this.PersonType() === "Physical";

		const isInvisibleCaptcha = this.isInvisibleCaptchaUsageZone();

		const operativeYaCaptcha = isCommonLogin
			? this.yaCaptchaLogin
			: isPhysicalRegistration
				? this.yaCaptchaPhysicalRegister
				: null;

		if (operativeYaCaptcha) {
			// Если на форме была капча - пересоздаем, т.к. второй запрос со старым токеном не пройдет
			operativeYaCaptcha.reset();

			/* На видимой капче пробуем провести авто-проверку, чтоб клиент не проходил капчу дважды.
			   На невидимой капче не делаем, т.к. успешное прохождение является триггером для запуска логина.
			 */
			if (!isInvisibleCaptcha) {
				operativeYaCaptcha.startValidation();
			}
		}
	}

	_handleSendSmsCodeResponse (res) {
		const status: PhoneLoginStatus = res.responseJSON.Status;
		this.anotherCodeReqIsAllowed(false);

		if (status === 'Blocked') {
			this.notificationLineText(phoneLoginErrorMessage.blocked);
			this.notificationLine(true);
			return;
		}
		if (status === 'ConfirmedPhoneNotFound') {
			this.phoneAuthRedirectModal._show();
			return;
		}
		if (status === 'NoProfileBinding') {
			this.phoneAuthRedirectModal._show();
			return;
		}
		if (status === 'InvalidPersonType') {
			this.phoneAuthRedirectModal._show();
			return;
		}
		if (status === 'SmsQuotaExceeded') {
			const time = res.responseJSON.Data.TryAfterSeconds;
			this.Code('');
			this.notificationWithTimerText(phoneLoginErrorMessage.smsQuotaExceeded);
			this.notificationWithTimer(true);
			this.timer.change({
				timeout: [time, 'second'],
			});
			return;
		}
		if (status === 'Success') {
			if (this.timer.timeoutRemaining() > 0) {
				this.timer.change({
					timeout: [1, 'second'],
				});
			}
			this.notificationWithTimer(false);
			this.notificationWithTimerAndBlocker(false);
			this.smsIsSent(true);
			// Focus on code input for desktop
			if (!this.isMobile()) {
				setTimeout(() => {
					const $codeInput = $('#dms-login-code-input');
					$codeInput.focus();
				}, 500);
			}
		}
	}

	_requestSmsCode () {
		const statisticsQueries = getStatisticsQueries();

		// <cmsApiBaseUrl>/cmsapi/lk/auth/physical/dms/sms/send
		return server2.my.cmsapi
			.withStatisticsQueries(statisticsQueries)
			.post(
				["lk", "auth", "physical", "dms", "sms", "send"],
				{ body: this.toPhoneAuthJS() },
			)
			.then(this._handleSendSmsCodeResponse.bind(this))
			.catch((e: Error) => {
				e.userFriendlyMessages = ['Ошибка отправки кода'];
				throw e;
			});
	}

	_getAnotherCodeClick () {
		this._removeNotifications();

		const validationGroup = this.validationGroup({
			mode: 'smsLoginSmsSending',
		});

		if (!validationGroup.guard()) {
			return this._busy
				.add(this._requestSmsCode())
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_loginByPhone () {
		const credentialsBody = this.toSmsPhoneAuthJS();
		const statisticsQueries = getStatisticsQueries();
		// <cmsApiBaseUrl>/cmsapi/lk/auth/physical/dms/sms
		return server2.my.cmsapi
			.withStatisticsQueries(statisticsQueries)
			.post(
			[
				"lk",
				"auth",
				"physical",
				"dms",
				"sms",
			],
			{
				body: credentialsBody,
			}
			)
			.then(async (res) => {
				const status: PhoneLoginStatus = res.responseJSON.Status;
				if (status === 'Blocked') {
					this.notificationLineText(phoneLoginErrorMessage.blocked);
					this.notificationLine(true);
					return;
				}
				if (status === 'DmsAdminUntrustedPerimeter') {
					page.notifications.push({
						tags: ['myrgs-auth-form'],
						css: { 'notification-danger': true },
						expire: 'error',
						message: phoneLoginErrorMessage.dmsAdminUntrustedPerimeter,
					});
					return;
				}
				if (status === 'ConfirmedPhoneNotFound') {
					this.phoneAuthRedirectModal._show();
					return;
				}
				if (status === 'NoProfileBinding') {
					this.phoneAuthRedirectModal._show();
					return;
				}
				if (status === 'InvalidPersonType') {
					this.phoneAuthRedirectModal._show();
					throw new Error;
				}
				if (status === 'OutOfAttempts') {
					const time = res.responseJSON.Data.TryAfterSeconds;
					this.Code('');
					this.notificationWithTimerText(phoneLoginErrorMessage.outOfAttempts);
					this.notificationWithTimerAndBlocker(true);
					this.viewCanBeBlocked(true);
					this.timer.change({
						timeout: [time, 'second'],
					});
					return;
				}
				if (status === 'InvalidCode') {
					this.Code('');
					this.notificationWithTimerText(phoneLoginErrorMessage.invalidCode);
					this.timer.change({
						timeout: [60, 'second'],
					});
					this.notificationWithTimer(true);
					this.anotherCodeReqIsAllowed(true);
					return;
				}
				if (status === 'Success') {
					return this._handleWebPushSubscription(res);
				}
			})
			.then(profile.update)
			.then(server.util.filter.authenticated)
			.then(async () => {
				const res = await server.my.cmsapi.lk.getUserProfileSummary();
				const { responseJSON } = res;
				this.currentUserEmail(responseJSON.Email);
				this.currentUserProfileId(responseJSON.UserProfileID);
				page.notifications.removeAll({
					tags: ["myrgs-auth-form"],
				});
			})
			.then(() => {
				// this._handleFaceIdInterception();
				this.emit("authSuccess");
			})
			.catch((e: Error) => {
				throw e;
			});
	}

	_login (credentials?) {
		const lkTypeStorageVal = this._lkTypeStorage.getLkType();
		const lkCompanyStorageVal = this._lkTypeStorage.getLkCompany();
		const credentialsBody = credentials ? credentials : this.toAuthJS();

		if (lkTypeStorageVal) {
			credentialsBody.LkType = lkTypeStorageVal;
		}

		if (lkCompanyStorageVal) {
			credentialsBody.InsurantId = lkCompanyStorageVal;
		}

		const isCommonLogin = this.UserHasPassword();
		const isPhysicalRegistration = this.registrationMode() && this.PersonType() === "Physical";

		const captcha = {
			token: isCommonLogin
				? this.yaCaptchaLogin.getValidationToken()
				: isPhysicalRegistration
					? this.yaCaptchaPhysicalRegister.getValidationToken()
					: '',
		};

		const statisticsQueries = getStatisticsQueries();

		return server2.my.cmsapi
			.withYaCaptcha(captcha)
			.withStatisticsQueries(statisticsQueries)
			.post(
			[
				"lk",
				"auth",
				...(credentialsBody && lkTypeStorageVal ? ["lk_type"] : []),
			],
			{
				body: credentialsBody,
			}
			)
			.then(async (res) => {
				return this._handleWebPushSubscription(res);
			})
			.then(profile.update)
			.then(server.util.filter.authenticated)
			.then(async () => {
				const res = await server.my.cmsapi.lk.getUserProfileSummary();
				const { responseJSON } = res;
				this.currentUserEmail(responseJSON.Email);
				this.currentUserProfileId(responseJSON.UserProfileID);
				page.notifications.removeAll({
					tags: ["myrgs-auth-form"],
				});
			})
			.then(() => {
				if (!credentials) {
					this._handleFaceIdInterception();
					this.emit("authSuccess");
				} else {
					this.emit("authSuccess");
				}
			})
			.catch((e: Error) => {
				this._yaCaptchaReset();

				if (e.name === "CaptchaValidationException") {
					TraceKit.tryReport(`YaCaptcha: проверка не пройдена для ${this.Email()}`);
				}

				/* eslint-disable max-len */
				const handledErrors = {
					NeedLkType: "Необходимо указать тип личного кабинета",
					InvalidCredentials: "Проверьте, правильно ли введен пароль",
					Blocked:
						"Превышено количество неудачных попыток ввода пароля. Повторите вход позднее.",
					// InvalidPersonType: 'Неверный тип личного кабинета',
					NotFound: "Пользователя с таким E-mail не существует",
					Lock: "Пользователь заблокирован",
					DmsAdminUntrustedPerimeter: phoneLoginErrorMessage.dmsAdminUntrustedPerimeter,
				};
				const message = handledErrors[e.message];
				/* eslint-enable max-len */

				if (!message) {
					throw e;
				}

				if (e.message === "NeedLkType") {
					this.lkTypeControllerInstance._showLkTypeModal({
						credentials: this.toAuthJS(),
						callback: arg => this._login(arg),
					});
				}

				if (e.message === 'DmsAdminUntrustedPerimeter') {
					page.notifications.push({
						tags: ['myrgs-auth-form'],
						css: { 'notification-danger': true },
						expire: 'error',
						message,
					});
				}

				if (e.message === "Blocked") {
					this.notificationLineText(message);
					this.notificationLine(true);
					this._scrollPlateToView();
				}

				if (e.message === "Lock") {
					this.notificationPlateText(message);
					this.notificationPlate(true);
					this._scrollPlateToView();
				}

				if (e.message === "InvalidCredentials") {
					this.notificationPassword(true);
					this._scrollInputWithErrorToView(
						"#password-wrapper-error-to-scroll"
					);
				}

				if (e.message === "NotFound") {
					this.notificationEmail(true);
					this._scrollInputWithErrorToView(
						"#email-wrapper-error-to-scroll"
					);
				}

				// page.notifications.push({
				// 	tags: ['myrgs-auth-form'],
				// 	css: { 'notification-danger': true },
				// 	expire: 'error',
				// 	message,
				// });

				e.handled = {
					type: "notification",
					message,
				};

				throw e;
			});
	}

	async _loginClick () {
		this._removeNotifications();

		const isSmsLogin = this.loginByPhoneIsActive();
		const isSmsLoginSmsSending = isSmsLogin && !this.smsIsSent();

		if (isSmsLogin && isDmsAuthenticationShouldBeBlocked) {
			showDmsAuthenticationBlockedStub();
			return;
		}

		await this._askNotificationPermission();

		const validationGroup = this.validationGroup({
			mode: !isSmsLogin
				? 'login'
				: isSmsLoginSmsSending ? 'smsLoginSmsSending' : 'smsLogin',
		});

		// 1. Проверка капчи на регистрации ФЛ
		const isPhysicalRegistration = this.registrationMode() && this.PersonType() === "Physical";
		if (isPhysicalRegistration && !this.yaCaptchaPhysicalRegister.isValidated()) {
			this.yaCaptchaPhysicalRegisterValidationSource.setError(CAPTCHA_IGNORED_ERROR);

			// Остальные поля тоже валидируем, чтоб подсветились
			validationGroup.guard();

			return;
		}

		// 2. Валидация формы
		if (validationGroup.guard()) {
			return;
		}

		// 3. Логин.
		// 3.1. Вход по СМС
		if (isSmsLogin) {
			return this._busy
				.add(isSmsLoginSmsSending ? this._requestSmsCode() : this._loginByPhone())
				.catch(ignoreHandledErrors)
				.done();
		}

		// 3.2. Регистрация ФЛ (видимая капча)
		if (isPhysicalRegistration) {
			return this._busy
				.add(this._login())
				.catch(ignoreHandledErrors)
				.done();
		}

		// 3.3. Логин по email (скрытая капча).
		if (!this.isYaCaptchaJsFetched()) {
			TraceKit.tryReport(
				`Логин со скрытой капчей прерван. JS для smartCaptcha не был загружен успешно`,
				{ quiet: false });
			return;
		}

		// 3.3.1. Просто запускаем капчу - логин запустится при успехе проверки.
		this.yaCaptchaLogin.startValidation();
	}

	_getResetPasswordHandledErrors = () => ({
		AlreadySent: "Пароль уже был отправлен. Дождитесь получения.",
		NotFound: `Личного кабинета для указанного e-mail не существует. 
			Для того чтобы завести личный кабинет, 
			воспользуйтесь кнопкой "Регистрация".`,
	});

	_resetPasswordServerRequest () {
		return server2.any.rest.post(
			[lkRoute.prefix, lkRoute.profiles, lkRoute.resetPassword],
			{
				body: this.toResetPasswordJS(),
			}
		);
	}

	_setCaptcha () {
		return server.any.cmsapi.captcha
			.generateKey()
			.then(response => {
				const key = response.responseJSON;
				this.CaptchaKey(key);
				return key;
			})
			.catch(function (error) {
				console.log("request capcha error: ", error);
				return "";
			})
			.done();
	}

	_checkCaptcha () {
		if (this.isCaptchaChecked()) {
			return true;
		}

		const key = this.CaptchaKey();
		const val = this.CaptchaValue();

		return server.any.cmsapi.captcha
			.check({ query: { key: key, value: val } })
			.then(response => {
				const data = response.responseJSON;
				if (data) {
					this.isCaptchaChecked(true);
				} else {
					this.isCaptchaChecked(false);
					this.CaptchaValue.setError("Неверный код.");
					this._setCaptcha();
				}
				return data;
			});
	}

	_switchToPhoneForm () {
		this.loginByPhoneIsActive(true);
	}

	_switchToEmailForm () {
		this.loginByPhoneIsActive(false);
	}

	_goToEmailHandler = () => {
		this.loginByPhoneIsActive(false);
		this.phoneAuthRedirectModal._hide();
	}

	_getLoginParamsFromUrl () {
		if (this.isPwaMode()) {
			return false;
		}
		const queryString = window.location.search;
		// eslint-disable-next-line no-undef
		const urlParams = new URLSearchParams(queryString);
		const login = urlParams.get('login');
		return login === 'email';
	}

	toPhoneAuthJS = () => {
		return _.pick(this.toJS(), [
			'Phone',
		]);
	}

	toSmsPhoneAuthJS = () => {
		return _.pick(this.toJS(), [
			'Phone',
			'Code',
		]);
	}

	_registerJuridicalPersonClick () {
		if (this._busy.isBusy()) {
			return;
		}

		if (this.isCaptchaChecked()) {
			this._registerJuridicalPerson();
		} else {
			this._checkCaptcha().then(result => {
				if (!result) {
					return;
				}

				this._registerJuridicalPerson();
			});
		}
	}

	_registerJuridicalPerson () {
		this.CaptchaValue.clearError();

		this.validationGroup({ mode: "login" }).showAllMessages(false);

		if (!this.validationGroup({ mode: "registerJuridical" }).guard()) {
			this._busy
				.add(
					this._register().then(() => {
						this.juridicalPersonPasswordVisible(true);
					})
				)
				.catch(ignoreHandledErrors)
				.done();
		}
	}

	_registrationClick = () => {
		this.emit("registrationMode");

		this.loginMode(false);
		this.registrationMode(true);

		this.Phone('');
		this.Code('');
		this.loginByPhoneIsActive(false);
	};

	_onPhisicalClick = () => {
		this.isTypeChecked("Physical");
		this.isPersonTypeIp(false);
		this.PersonType("Physical");
	};

	_onIpClick = () => {
		this.isTypeChecked("Ip");
		this.isPersonTypeIp(true);
		this.PersonType("Ip");
		window.sessionStorage.setItem("lkType", "Ip");
	};

	_onJurdicalClick = () => {
		this.isTypeChecked("Juridical");
		this.isPersonTypeIp(false);
		this.PersonType("Juridical");
		window.sessionStorage.setItem("lkType", "Jurdical");
	};

	_onGoToLoginModeClick = () => {
		this.loginMode(true);
		this.registrationMode(false);
	};

	_onOsopoOsgop = () => {
		this.ProductType("OSOPO");
	};

	validationArray ({ mode }: ExtendedValidationOptions) {
		if (mode === "login") {
			const validate = [this.Email, this.Password];
			if (this.UserHasPassword() === false) {
				validate.push(this.Phone);
			}
			if (this.isPersonTypeJuridical() || this.registrationMode()) {
				validate.push(this.rulesAccepted);
			}
			return validate;
		}

		if (mode === "esia" && this.loginMode()) {
			return [];
		}

		if (mode === "esia" && this.registrationMode()) {
			return [this.rulesAccepted];
		}

		if (mode === "resetPassword") {
			return [this.Email];
		}

		if (mode === "registerJuridical") {
			return [this.Email, this.CaptchaValue];
		}

		if (mode === 'smsLoginSmsSending') {
			return [this.Phone];
		}

		if (mode === 'smsLogin') {
			return [this.Phone, this.Code];
		}

		return super.validationArray(...arguments);
	}

	_onBankAuthClick = () => {
		if (isDmsAuthenticationShouldBeBlocked) {
			showDmsAuthenticationBlockedStub();
			return;
		}

		return this._busy
			.add(this._getBankAuthUrl())
			.catch(ignoreHandledErrors)
			.done();
	}

	async _getBankAuthUrl () {
		return server2.any.rest.get(
			['auth', 'links', 'vtbid', 'dms'],
		).then((res) => {
			const status = _.get(res, 'responseJSON.Status');
			if (status !== 'Success') {
				throw new Error();
			}
			const url = _.get(res, 'responseJSON.Data.VtbIdLink');
			if (url) {
				window.location.href = url;
			}
		}).catch((err) => {
			throw err;
		});
	}

	_handleBankAuthErrors () {
		const queryString = window.location.search;
		// eslint-disable-next-line no-undef
		const urlParams = new URLSearchParams(queryString);
		const status: BankAuthStatus | null = urlParams.get(VTB_AUTH_URL_STATUS);
		if (this.timer.timeoutRemaining() > 0) {
			this.timer.change({
				timeout: [1, 'second'],
			});
		}
		const timeFromUrl = urlParams.get(TIMER_URL_PARAM);
		const time = timeFromUrl ? parseInt(timeFromUrl) : 1;

		if (!status) {
			return;
		}

		if (status !== 'Success') {
			switch (status) {
				case 'PersonNotFound':
					this.errorWithRedirectModal = new Modal({
						templateMode: "body",
						title: "New title",
						template: {
							html: BankAuthErrorModalTemplate(),
							data: {
								isPwaMode: this.isPwaMode,
								withRegistration: true,
								text: bankAuthErrorMessage.PersonNotFound[0] || '',
								additionalText: bankAuthErrorMessage.PersonNotFound[1] || '',
								goToHelpCenterHandler: this._goToEmailHandler,
								goToRegistrationHandler: this._registrationClick,
							},
						},
						userCanClose: true,
						css: { "modal-no-phone": true },
					});
					this.errorWithRedirectModal._createModal();
					this.errorWithRedirectModal._applyBindings();
					this.errorWithRedirectModal._show();
					break;

				case 'MobilePhoneMismatch':
					this.errorWithRedirectModal = new Modal({
						templateMode: "body",
						title: "New title",
						template: {
							html: BankAuthErrorModalTemplate(),
							data: {
								isPwaMode: this.isPwaMode,
								withRegistration: false,
								text: bankAuthErrorMessage.MobilePhoneMismatch[0] || '',
								additionalText: bankAuthErrorMessage.MobilePhoneMismatch[1] || '',
								goToHelpCenterHandler: this._goToEmailHandler,
								goToRegistrationHandler: this._registrationClick,
							},
						},
						userCanClose: true,
						css: { "modal-no-phone": true },
					});
					this.errorWithRedirectModal._createModal();
					this.errorWithRedirectModal._applyBindings();
					this.errorWithRedirectModal._show();
					break;

				case 'TemporaryBanned':
					this.timer.change({
						timeout: [time, 'second'],
					});
					this.errorWithRedirectModal = new Modal({
						templateMode: "body",
						title: "New title",
						template: {
							html: BankAuthTimerErrorModalTemplate(),
							data: {
								text: bankAuthErrorMessage.TemporaryBanned[0] || '',
								additionalText: bankAuthErrorMessage.TemporaryBanned[1] || '',
								timerString: this.timerString,
							},
						},
						userCanClose: true,
						css: { "modal-no-phone": true },
					});
					this.errorWithRedirectModal._createModal();
					this.errorWithRedirectModal._applyBindings();
					this.errorWithRedirectModal._show();
					break;

				case 'DmsAdminUntrustedPerimeter':
					page.notifications.push({
						css: { "notification-danger": true },
						message: bankAuthErrorMessage.DmsAdminUntrustedPerimeter,
					});
					break;

				case 'VtbIdInteropFailure':
					page.notifications.push({
						css: { "notification-danger": true },
						message: bankAuthErrorMessage.VtbIdInteropFailure,
					});
					break;

				default:
					page.notifications.push({
						css: { "notification-danger": true },
						message: bankAuthErrorMessage.Default,
					});
					break;
			}
		}
		window.history.replaceState({}, '', window.location.origin);
	}

	_showPhoneFormPwa () {
		this.phoneFormMobileRequired(true);
	}
}

export default AuthModel;
